import { render, staticRenderFns } from "./SettingKeyApi.vue?vue&type=template&id=390b95e9&scoped=true"
import script from "./SettingKeyApi.vue?vue&type=script&lang=js"
export * from "./SettingKeyApi.vue?vue&type=script&lang=js"
import style0 from "./SettingKeyApi.vue?vue&type=style&index=0&id=390b95e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b95e9",
  null
  
)

export default component.exports